/* eslint-disable prefer-template */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/no-array-index-key */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import moment from "moment";
import { withNamespaces } from "react-i18next";
import { replace } from "react-router-redux";
import { Object } from "core-js";
import {
  fetchLocationBookings,
  fetchLocationDetails,
  fetchLocations,
  resetLocationDetails,
  setSelectedSlots
} from "../Exams/Exams.ducks";
import { weekDays, BASE_URL } from "../../../config/constants";
import BookingsToolbar from "../components/BookingsToolbar";
import LocationSelector from "./LocationSelector";
import ManualAssignmentTable from "./ManualAssignmentTable";
import NoInformation from "../../../components/NoInformation";
import TableBottomBar from "./TableBottomBar";
import TableTitleBar from "./TableTitleBar";
import TableTopBar from "./TableTopBar";
// Styles
import styles from "./ManualAssignment.css";

class ManualAssignment extends Component {
  state = {
    assignmentDate: new Date(),
    offset: 0,
    selectedCells: undefined,
    hoveredCell: undefined,
    startDate: undefined
  };

  tableRef = React.createRef();

  componentDidMount() {
    const { fetchLocations, selectedSlots, locationDetails, occupiedSlots } = this.props;
    if (locationDetails && locationDetails.id && selectedSlots && occupiedSlots) {
      this.setState({
        locationId: locationDetails.id,
        selectedCells: selectedSlots.selectedCells,
        offset: selectedSlots.offset,
        assignmentDate: selectedSlots.assignmentDate
      });
    } else fetchLocations();
  }

  onChangeLocation = (event) => {
    const { fetchLocationDetails, resetLocationDetails, fetchLocationBookings } = this.props;

    const locationId = event.target.value;
    resetLocationDetails();
    this.setState({
      assignmentDate: new Date(),
      offset: 0,
      selectedCells: undefined,
      hoveredCell: undefined
    });
    if (locationId) {
      fetchLocationDetails({ locationId });
      fetchLocationBookings({
        locationId,
        date: moment().format(`L`),
        offset: 0
      });
      this.setState({ locationId });
    }
  };

  getWeekDay = (day) => weekDays.findIndex((el) => day === el);

  getOpeningHoursForDay = (date) => {
    const {
      locationDetails: { openingHours },
      fetchLocationBookings
    } = this.props;
    const { offset, locationId, navigating, previousNavigation, assignmentDate } = this.state;

    // Run only if the navigateDates function is not running
    if (!navigating) {
      // Check if the day exists in the location opening hours
      const locationDay = openingHours.find((el) => this.getWeekDay(el.weekday) === date.getDay());

      if (locationDay) {
        const list = [];
        const start = parseInt(locationDay.openingPeriodFrom.split(`:`)[0], 10);
        const end = parseInt(locationDay.openingPeriodTo.split(`:`)[0], 10);
        for (let i = start; i < end; i += 1) {
          list.push(i);
        }
        // return the day opening hours if exists
        return list;
      }
      // If there is no opening hours for the selected date
      // Move to the next day by default
      // Move to the previous day if "previousNavigation" is set to "true"
      const currentDay = new Date();
      const sameDay = moment(assignmentDate).isSame(currentDay, "day");
      previousNavigation ? date.setDate(date.getDate() - 1) : date.setDate(date.getDate() + 1);
      this.setState((prevState) => ({
        assignmentDate: date,
        // Set start date to the next day if the current day has no opening hours
        ...(!prevState.startDate && sameDay && !previousNavigation && { startDate: date })
      }));
      const diffDays = moment(date).diff(moment(currentDay), `days`);
      if (
        (!previousNavigation && diffDays === 4 * (+offset + 1) - 1) ||
        (previousNavigation && diffDays === 4 * (+offset - 1) + 2)
      ) {
        // Load the next/previous 4 days bookings if they are not loaded
        let nextOffset;
        previousNavigation ? (nextOffset = offset - 1) : (nextOffset = offset + 1);
        this.setState({ offset: nextOffset });
        fetchLocationBookings({
          locationId,
          date: moment().format(`L`),
          offset: nextOffset
        });
      } else {
        // Move to the next/previous day if its bookings are already loaded
        this.getOpeningHoursForDay(date);
      }
    }
    return null;
  };

  // Check if the time span is available or not
  checkAvailabality = ({ stationId, hour, index }) => {
    const { occupiedSlots } = this.props;
    const dateOccupiedSlots = occupiedSlots && this.getSlotsForDate();
    const slot = dateOccupiedSlots.bookings.find((el) => {
      const bookingHour = parseInt(el.timeFrom.split(`:`)[0], 10);
      const bookingMinute = parseInt(el.timeFrom.split(`:`)[1], 10);
      return (
        el.stationId === stationId &&
        bookingHour === hour &&
        bookingMinute <= 15 * index &&
        bookingMinute + el.duration > 15 * index
      );
    });
    if (slot) return true;
    return false;
  };

  // Get the bookings of the assignment date
  getSlotsForDate = () => {
    const { occupiedSlots } = this.props;
    const { assignmentDate } = this.state;
    return occupiedSlots.find(
      (el) => moment(el.date).format(`L`) === moment(assignmentDate).format(`L`)
    );
  };

  navigateDates = ({ prev, next }) => {
    const { locationId, offset } = this.state;
    const { fetchLocationBookings } = this.props;
    // Set "navigating" to avoid concurrency between navigateDates and getOpeningHoursForDay
    this.setState({
      navigating: true,
      selectedCells: undefined,
      hoveredCell: undefined,
      ...(prev ? { previousNavigation: true } : { previousNavigation: false })
    });
    this.setState(
      (prevState) => ({
        ...(next && {
          assignmentDate: moment(prevState.assignmentDate)
            .add(1, `d`)
            .toDate()
        }),
        ...(prev && {
          assignmentDate: moment(prevState.assignmentDate)
            .subtract(1, `d`)
            .toDate()
        })
      }),
      () => {
        const diffDays = moment(this.state.assignmentDate).diff(moment(), `days`);
        // Fetch bookings with the next/previous offset, after/before an amount of 4 days
        if (
          (next && diffDays === 4 * (+offset + 1) - 1) ||
          (prev && diffDays === 4 * (+offset - 1) + 2)
        ) {
          const newOffset = next ? +offset + 1 : +offset - 1;
          this.setState(
            {
              offset: newOffset
            },
            () => {
              fetchLocationBookings({
                locationId,
                date: moment().format(`L`),
                offset: newOffset
              });
            }
          );
        }
        // Set "navigating" to false, to
        this.setState({ navigating: false });
      }
    );
  };

  cellClick = ({ stationId, hour, index }) => {
    const { selectedCells } = this.state;
    // If the clicked cell is directly next the to the selected sequence
    // Append it to the selected items list
    if (
      selectedCells &&
      selectedCells[stationId] &&
      ((selectedCells[stationId][hour] &&
        (selectedCells[stationId][hour][+index - 1] ||
          selectedCells[stationId][hour][+index + 1])) ||
        (index === 0 &&
          selectedCells[stationId][+hour - 1] &&
          selectedCells[stationId][+hour - 1][3]) ||
        (index === 3 &&
          selectedCells[stationId][+hour + 1] &&
          selectedCells[stationId][+hour + 1][0]))
    ) {
      this.setState((prevState) => ({
        selectedCells: {
          ...prevState.selectedCells,
          [stationId]: {
            ...(prevState.selectedCells &&
              prevState.selectedCells[stationId] && {
                ...prevState.selectedCells[stationId]
              }),
            [hour]: {
              ...(prevState.selectedCells &&
                prevState.selectedCells[stationId] &&
                prevState.selectedCells[stationId][hour] && {
                  ...prevState.selectedCells[stationId][hour]
                }),
              [index]: true
            }
          }
        }
      }));
    }
    // If the clicked cell is not directly next the to the selected sequence
    // Reset the previous selection and select this cell
    else
      this.setState({
        selectedCells: {
          [stationId]: {
            [hour]: {
              [index]: true
            }
          }
        }
      });
  };

  cellMove = ({ stationId, hour, index }) => {
    const { selectedCells, hoveredCell } = this.state;
    // Check if the cell is already hovered to prevent multiple run at the same time
    if (hoveredCell !== stationId + hour + index) {
      if (
        selectedCells &&
        selectedCells[stationId] &&
        ((selectedCells[stationId][hour] &&
          (selectedCells[stationId][hour][index] ||
            selectedCells[stationId][hour][+index - 1] ||
            selectedCells[stationId][hour][+index + 1])) ||
          (index === 0 &&
            selectedCells[stationId][+hour - 1] &&
            selectedCells[stationId][+hour - 1][3]) ||
          (index === 3 &&
            selectedCells[stationId][+hour + 1] &&
            selectedCells[stationId][+hour + 1][0]))
      )
        this.setState(
          (prevState) => ({
            selectedCells: {
              ...prevState.selectedCells,
              [stationId]: {
                ...(prevState.selectedCells &&
                  prevState.selectedCells[stationId] && {
                    ...prevState.selectedCells[stationId]
                  }),
                [hour]: {
                  ...(prevState.selectedCells &&
                    prevState.selectedCells[stationId] &&
                    prevState.selectedCells[stationId][hour] && {
                      ...prevState.selectedCells[stationId][hour]
                    }),
                  [index]: true
                }
              }
            }
          }),
          () => {
            this.setState({
              hoveredCell: stationId + hour + index
            });
          }
        );
      else this.finishSelection();
    }
  };

  finishSelection = () => {
    const { active } = this.state;
    if (active) {
      this.setState({ hoveredCell: undefined, active: false });
    }
  };

  // Check if the cell is selected or not
  checkSelected = ({ stationId, hour, index }) => {
    const { selectedCells } = this.state;
    return (
      selectedCells &&
      selectedCells[stationId] &&
      selectedCells[stationId][hour] &&
      selectedCells[stationId][hour][index]
    );
  };

  clearSelection = () => {
    this.setState({ selectedCells: undefined, hoveredCell: undefined });
  };

  getAvailableMinutes = () => {
    const { selectedCells } = this.state;
    let availableMinutes = 0;
    Object.keys(selectedCells).forEach((station) => {
      Object.keys(selectedCells[station]).forEach((hour) => {
        Object.keys(selectedCells[station][hour]).forEach((slot) => {
          if (selectedCells[station][hour][slot] === true) {
            availableMinutes += 15;
          }
        });
      });
    });
    return availableMinutes;
  };

  // Start mouse dragging
  setActiveTrue = () => {
    this.setState({
      active: true
    });
  };

  // On Continue click
  onContinueClick = () => {
    const { selectedCells, offset, assignmentDate, locationId } = this.state;
    const { setSelectedSlots, replace } = this.props;

    const stationId = Object.keys(selectedCells)[0];
    const startHour = Object.keys(selectedCells[stationId])[0];
    const indexMinutes = Object.keys(selectedCells[stationId][startHour])[0];
    const formattedHour = (`0` + startHour).slice(-2);
    const formattedMinutes = (`0` + indexMinutes * 15).slice(-2);
    const startTime = moment(formattedHour + formattedMinutes, `hhmm`).format(`HH:mm:ss`);

    setSelectedSlots({
      selectedCells,
      offset,
      assignmentDate,
      availableMinutes: this.getAvailableMinutes(),
      startTime,
      stationId,
      locationId
    });
    replace(`${BASE_URL}/dashboard/assign/exams`);
  };

  render() {
    const { locations, t, locationDetails, occupiedSlots } = this.props;
    const { assignmentDate, active, selectedCells, locationId, startDate } = this.state;
    // Get array of opening hours for the selected date
    const openingHoursList =
      locationDetails &&
      locationDetails.openingHours.length &&
      this.getOpeningHoursForDay(assignmentDate);

    // Bookings assigned in the selected date
    const dateOccupiedSlots = occupiedSlots && this.getSlotsForDate();
    // Disable previous navigation if the selected date is the current date
    const currentDay = moment(startDate).format(`dddd L`) || moment().format(`dddd L`);
    const disablePreviousNav = moment(assignmentDate).format(`dddd L`) === currentDay;

    return (
      <div className="container" style={styles.container}>
        <BookingsToolbar />
        <LocationSelector
          onChangeLocation={this.onChangeLocation}
          locations={locations}
          defaultLocation={locationId || ``}
        />
        {locationDetails && openingHoursList && locationDetails.stations.length > 0 ? (
          <div style={styles.container}>
            <TableTopBar
              selectedCells={Boolean(selectedCells)}
              availableMinutes={selectedCells && this.getAvailableMinutes()}
              clearSelection={this.clearSelection}
            />
            <TableTitleBar
              assignmentDate={moment(assignmentDate).format(`dddd L`)}
              navigateDates={this.navigateDates}
              disablePreviousNav={disablePreviousNav}
            />
            <ManualAssignmentTable
              active={active}
              cellClick={this.cellClick}
              cellMove={this.cellMove}
              checkAvailabality={this.checkAvailabality}
              checkSelected={this.checkSelected}
              dateOccupiedSlots={dateOccupiedSlots}
              finishSelection={this.finishSelection}
              locationDetails={locationDetails}
              openingHoursList={openingHoursList}
              setActiveTrue={this.setActiveTrue}
              tableRef={this.tableRef}
            />
            <TableBottomBar
              disabled={Boolean(!selectedCells)}
              onContinueClick={this.onContinueClick}
            />
          </div>
        ) : null}
        {locationDetails && (!openingHoursList || locationDetails.stations.length === 0) ? (
          <NoInformation
            label={t(
              `modules.localization.register.authenticated.exams.noStationsOrNoOpeningHours`
            )}
          />
        ) : null}
      </div>
    );
  }
}

ManualAssignment.propTypes = {
  fetchLocationBookings: PropTypes.func.isRequired,
  fetchLocationDetails: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired,
  locationDetails: PropTypes.object,
  locations: PropTypes.array.isRequired,
  occupiedSlots: PropTypes.array,
  replace: PropTypes.func.isRequired,
  resetLocationDetails: PropTypes.func.isRequired,
  selectedSlots: PropTypes.object,
  setSelectedSlots: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  fetchLocationBookings,
  fetchLocationDetails,
  fetchLocations,
  resetLocationDetails,
  setSelectedSlots,
  replace
};

const mapStateToProps = (state) => ({
  locationDetails: state.exams.locationDetails,
  locations: state.exams.locations,
  occupiedSlots: state.exams.occupiedSlots,
  selectedSlots: state.exams.selectedSlots
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withNamespaces()
)(ManualAssignment);
